export * from "./allBlocks.pure";

import { RegisterAllNodeGeometryBlocks } from "./allBlocks.pure";
RegisterAllNodeGeometryBlocks();
